var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPipedriveIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 300,
  height: 301,
  fill: "none",
  viewBox: "0 0 300 301"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#26292C",
  d: "M125.014 123.641c0 20.089 10.191 41.761 32.618 41.761 16.632 0 33.448-12.984 33.448-42.056 0-25.487-13.219-42.598-32.895-42.598-16.032 0-33.171 11.262-33.171 42.893m41.072-80.109c40.212 0 67.25 31.848 67.25 79.256 0 46.663-28.483 79.24-69.202 79.24-19.414 0-31.849-8.315-38.352-14.334.047 1.427.077 3.025.077 4.732v63.277H84.203V87.108c0-2.451-.784-3.227-3.213-3.227H66.664v-36.92h34.955c16.093 0 20.213 8.19 20.997 14.504 6.533-7.322 20.075-17.933 43.47-17.933"
})));
export { SvgPipedriveIcon as ReactComponent };
export default __webpack_public_path__ + "527dc80a0a4e70b9b7c1636c4c10f1b1.svg";